/**
 * A-Image-with-Text Animation
 * Uses GSAP ScrollTrigger for scroll-based animations
 *
 * Fixed for cross-theme compatibility:
 * - Handle DOMContentLoaded timing issues with defer scripts
 * - Wait for GSAP to be available
 */

(function() {
  'use strict';

  function initAnimations() {
    // Check if GSAP and ScrollTrigger are available
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn('GSAP or ScrollTrigger not loaded. A-Image-with-Text animations will not work.');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const sections = document.querySelectorAll('.a-image-with-text');

    if (sections.length === 0) {
      return;
    }

    sections.forEach((section) => {
      const mediaItem = section.querySelector('.a-image-with-text__media-item');
      const image = section.querySelector('.a-image-with-text__media img, .a-image-with-text__media picture img');

      if (!mediaItem || !image) return;

      // Timeline for coordinated animations
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top 80%',
          end: 'top 20%',
          toggleActions: 'play none none none',
          // markers: true, // Uncomment for debugging
        }
      });

      // Animate pseudo element via CSS class
      tl.add(() => {
        mediaItem.classList.add('animated');
      }, 0);

      // Animate image: scale(1.1) opacity:0 → scale(1) opacity:1
      tl.fromTo(
        image,
        {
          scale: 1.1,
          opacity: 0
        },
        {
          scale: 1,
          opacity: 1,
          duration: 1.5,
          ease: 'power2.out',
          delay: 0.3
        },
        0
      );
    });
  }

  // Handle various loading scenarios
  if (document.readyState === 'loading') {
    // DOM is still loading
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    // DOM is already loaded (script loaded with defer or dynamically)
    // Use requestAnimationFrame to ensure GSAP scripts are executed
    requestAnimationFrame(function() {
      requestAnimationFrame(initAnimations);
    });
  }
})();
